import React from "react";
import Icon, { icons } from "./Icon";
import { NavLink } from "react-router-dom";

interface NavLinkProps {
  route: string;
  icon: keyof typeof icons;
  text: string;
  isMenuCollapsed: boolean;
}

const baseClasses =
  "flex items-center rounded-md transition duration-150 font-display font-semiBold  mt-[1px] p-2 gap-x-2 mb-3";
const SylobNavLink: React.FC<NavLinkProps> = ({ route, icon, isMenuCollapsed, text }) => {
  return (
    <NavLink to={route}>
      {({ isActive }) =>
        isActive ? (
          <>
            <div className={`${baseClasses} bg-secondary-light text-primary-dark }`}>
              <Icon icon={icon} variant="dark" />
              {!isMenuCollapsed && <div> {text}</div>}
              {!isMenuCollapsed && <div className="ml-auto border-r-2 border-primary-dark h-[35px]"></div>}
            </div>
          </>
        ) : (
          <>
            <div className={`${baseClasses}  hover:bg-secondary-light text-primary-dark `}>
              <Icon icon={icon} />
              {!isMenuCollapsed && <div>{text}</div>}
            </div>
          </>
        )
      }
    </NavLink>
  );
};

export default SylobNavLink;
